export default {
  nav: {
    home: 'Início',
    spreadsheet: 'CSSBuy Spreadsheet',
    guides: 'Guias',
    review: 'Review',
    shipping: 'Shipping',
    qc: 'QC',
    warehouse: 'Warehouse',
    safety: 'Segurança',
    faq: 'FAQ',
    shoppingGuide: 'Guia de Compras',
    categories: 'Categorias',
    language: 'Idioma',
    pt: 'Português',
    de: 'Deutsch',
    en: 'English',
  },
  hero: {
    title: 'CSSBuy Spreadsheet: Encontre Produtos, Links e Guias CSSBuy em um Só Lugar',
    subtitle: 'Encontre e organize informações sobre produtos, links, QC, envio, armazém e compras com nosso guia independente de CSSBuy Spreadsheet. Pesquise melhor, compare opções e tome decisões mais informadas antes de comprar.',
    ctaSpreadsheet: 'Explorar CSSBuy Spreadsheet',
    ctaGuides: 'Ver Guias CSSBuy',
    ctaMain: 'Visitar Site Principal',
    ctaBuy: 'Buy It Now',
  },
  categories: {
    title: 'Explore Categorias Populares',
    subtitle: 'Navegue pelas categorias mais procuradas e encontre o que você precisa com mais rapidez.',
    dropdownLabel: 'Selecione uma Categoria',
    dropdownPlaceholder: 'Escolher categoria...',
    shoes: 'Tênis',
    hoodies: 'Moletom / Hoodies',
    tshirts: 'Camisetas',
    jackets: 'Jaquetas',
    pants: 'Calças / Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear / Underpants',
    jersey: 'Jersey',
    accessories: 'Acessórios',
    bags: 'Bolsas',
    belts: 'Cintos',
    perfumes: 'Perfumes',
    other: 'Outros',
    cta: 'Ver Spreadsheet →',
  },
  trust: {
    independent: 'Guia Independente',
    updated: 'Conteúdo Atualizado',
    multilingual: 'Multilíngue',
    safety: 'Foco em Segurança',
  },
  whatIs: {
    title: 'O que é um CSSBuy Spreadsheet?',
    intro: 'Um CSSBuy Spreadsheet é uma ferramenta de organização que reúne informações sobre produtos, links, categorias e recursos relacionados ao CSSBuy. Ele ajuda compradores a pesquisar, comparar e encontrar o que procuram de forma mais eficiente.',
    point1: 'Organize produtos por categoria para pesquisa mais rápida',
    point2: 'Compare links e opções antes de decidir',
    point3: 'Verifique informações de QC, shipping e warehouse',
    point4: 'Tome decisões mais informadas com dados organizados',
    cta: 'Ler Guia Completo',
  },
  howItWorks: {
    title: 'Como Funciona',
    step1: 'Encontrar',
    step1Desc: 'Navegue pelas categorias e encontre produtos relevantes no spreadsheet.',
    step2: 'Comparar',
    step2Desc: 'Compare links, preços e opções disponíveis.',
    step3: 'Verificar QC',
    step3Desc: 'Confira fotos de QC e avaliações quando disponíveis.',
    step4: 'Analisar Shipping',
    step4Desc: 'Entenda os custos e opções de envio para seu país.',
    step5: 'Decidir',
    step5Desc: 'Tome uma decisão informada com todas as informações organizadas.',
  },
  guides: {
    title: 'Guias em Destaque',
    spreadsheetGuide: 'CSSBuy Spreadsheet Guide',
    spreadsheetGuideDesc: 'Aprenda a usar o CSSBuy Spreadsheet para pesquisar e organizar produtos de forma eficiente.',
    reviewGuide: 'CSSBuy Review 2026',
    reviewGuideDesc: 'Análise independente do CSSBuy: funcionalidades, shipping, warehouse e segurança.',
    shippingGuide: 'CSSBuy Shipping Cost',
    shippingGuideDesc: 'Guia completo sobre custos de envio, opções de frete e cálculos por país.',
    qcGuide: 'CSSBuy QC Guide',
    qcGuideDesc: 'Como interpretar fotos de QC e verificar a qualidade dos produtos antes do envio.',
    readMore: 'Ler Mais',
  },
  pillars: {
    title: 'Artigos Essenciais CSSBuy',
    subtitle: 'Explore nossos guias completos sobre CSSBuy Spreadsheet, shipping, QC, segurança, armazém e muito mais.',
    readMore: 'Ler Artigo',
  },
  products: {
    title: 'Catálogo de Produtos',
    subtitle: 'Navegue pelos produtos da nossa loja parceira e encontre o que você procura.',
    buyNow: 'Comprar Agora',
    viewAll: 'Ver Todos',
  },
  cta: {
    title: 'CSSBuy Spreadsheet',
    subtitle: 'Visite nosso site principal para explorar o CSSBuy Spreadsheet completo, encontrar produtos e começar a comprar com mais segurança.',
    buttonSpreadsheet: 'CSSBuy Spreadsheet',
    buttonBuy: 'Buy It Now',
    buttonVisit: 'Visitar Site Principal',
  },
  footer: {
    about: 'Sobre',
    editorial: 'Política Editorial',
    contact: 'Contato',
    privacy: 'Privacidade',
    terms: 'Termos',
    disclaimer: 'Este site é um recurso informativo independente e não é o site oficial do CSSBuy. As informações podem mudar. Sempre verifique os dados atuais de produtos, pagamentos, envio e conta através dos canais oficiais apropriados antes de comprar.',
    copyright: '© 2026 cssbuybr.tattoo — Guia Independente CSSBuy Spreadsheet',
    visitMain: 'Visitar Site Principal',
  },
  article: {
    title: 'CSSBuy Spreadsheet 2026: Guia Completo e Links de Produtos',
    metaDesc: 'Guia completo do CSSBuy Spreadsheet 2026: o que é, como usar, categorias, QC, shipping e segurança. Recurso independente para pesquisar produtos com mais confiança.',
    breadcrumbHome: 'Início',
    breadcrumbArticle: 'CSSBuy Spreadsheet',
    updated: 'Atualizado em 26 de agosto de 2026',
    author: 'Equipe Editorial CSSBuy Spreadsheet',
    reviewed: 'Revisado por especialistas em compras internacionais',
    quickAnswer: 'O CSSBuy Spreadsheet é uma ferramenta de organização que reúne informações sobre produtos, links e recursos relacionados ao CSSBuy. Ele ajuda compradores a pesquisar, comparar e encontrar produtos de forma mais eficiente, organizando dados por categoria e fornecendo acesso rápido a informações de QC, shipping e warehouse.',
    h1: 'CSSBuy Spreadsheet 2026: Guia Completo e Links de Produtos',
    h2What: 'O que é o CSSBuy Spreadsheet?',
    h2WhatP1: 'O CSSBuy Spreadsheet é um recurso organizacional desenvolvido para ajudar compradores a navegar pelo vasto catálogo de produtos disponíveis através do CSSBuy. Ele funciona como um diretório estruturado onde informações sobre produtos, links, categorias e recursos são compilados de forma sistemática.',
    h2WhatP2: 'Ao contrário de uma simples lista de links, um spreadsheet bem organizado permite que você filtre por categorias, compare opções e acesse guias específicos sobre cada tipo de produto. Isso é especialmente útil para quem está começando a explorar o mundo das compras internacionais e precisa de um ponto de partida confiável.',
    h2How: 'Como Usar o CSSBuy Spreadsheet',
    h2HowP1: 'Usar o CSSBuy Spreadsheet é um processo simples que pode transformar sua experiência de pesquisa. Primeiro, identifique a categoria de produto que você está procurando — seja tênis, roupas, acessórios ou eletrônicos. Navegue até essa categoria no spreadsheet e explore as opções disponíveis.',
    h2HowP2: 'Ao encontrar um produto interessante, verifique as informações de QC (Quality Control) quando disponíveis. Fotos de QC são essenciais para avaliar a qualidade real do item antes de fazer uma compra. Também preste atenção às informações de shipping e warehouse para entender os custos totais e o tempo de entrega.',
    h2Categories: 'Categorias do CSSBuy Spreadsheet',
    h2CategoriesP1: 'O CSSBuy Spreadsheet organiza produtos em categorias claras e intuitivas. As principais categorias incluem:',
    catShoes: 'Tênis e Sneakers — desde modelos casuais até edições limitadas',
    catHoodies: 'Moletom e Hoodies — roupas de inverno e peças de streetwear',
    catTshirts: 'Camisetas — básicas, estampadas e edições especiais',
    catJackets: 'Jaquetas — casacos, parkas e corta-vento',
    catPants: 'Calças e Shorts — jeans, cargo, esportivas e casuais',
    catAccessories: 'Acessórios — cintos, óculos, joias e itens diversos',
    catBags: 'Bolsas — mochilas, carteiras, bolsas de viagem',
    catPerfumes: 'Perfumes — fragrâncias e produtos de cuidado pessoal',
    h2Qc: 'CSSBuy QC: Quality Control e Fotos',
    h2QcP1: 'O QC (Quality Control) é um dos recursos mais importantes do CSSBuy. Quando você compra um produto, o agente pode tirar fotos detalhadas do item antes de enviá-lo para você. Isso permite verificar a qualidade, cor, tamanho e acabamento real do produto.',
    h2QcP2: 'Fotos de QC são particularmente valiosas para produtos onde os detalhes importam, como tênis, roupas de marca e acessórios. Sempre que possível, solicite fotos de QC e as compare com as imagens originais do vendedor para identificar discrepâncias.',
    h2Shipping: 'CSSBuy Shipping Cost: Custos de Envio',
    h2ShippingP1: 'O custo de envio do CSSBuy depende de vários fatores: país de destino, peso do pacote, dimensões, método de envio escolhido e se você opta por serviços adicionais como seguro ou embalagem reforçada. Países como Brasil, Alemanha, Estados Unidos e Reino Unido têm opções diferentes com custos variados.',
    h2ShippingP2: 'Antes de finalizar uma compra, é essencial calcular o custo total incluindo o produto, taxas do agente, shipping e possíveis impostos de importação. Use o spreadsheet para comparar diferentes cenários e escolher a opção mais econômica para sua situação.',
    h2Safety: 'CSSBuy Safety: Segurança e Precauções',
    h2SafetyP1: 'A segurança é uma prioridade ao usar qualquer serviço de compras internacionais. Sempre verifique se você está no site correto, nunca compartilhe sua senha, confirme preços antes de pagar e verifique fotos de QC quando disponíveis.',
    h2SafetyP2: 'Este spreadsheet é um recurso informativo independente. Ele não garante a qualidade dos produtos, não é uma certificação oficial e não substitui sua própria pesquisa. Sempre verifique informações atualizadas através de canais oficiais antes de fazer compras.',
    h2Table: 'CSSBuy Spreadsheet vs Pesquisa Normal',
    feature: 'Recurso',
    spreadsheet: 'CSSBuy Spreadsheet',
    normalSearch: 'Pesquisa Normal',
    prodDiscovery: 'Descoberta de Produtos',
    prodDiscoveryS: 'Fácil e organizada',
    prodDiscoveryN: 'Média',
    organization: 'Organização',
    organizationS: 'Alta',
    organizationN: 'Baixa',
    categorySearch: 'Busca por Categoria',
    categorySearchS: 'Sim',
    categorySearchN: 'Variável',
    qcRef: 'Referência de QC',
    qcRefS: 'Disponível quando fornecido',
    qcRefN: 'Variável',
    beginnerFriendly: 'Amigável para Iniciantes',
    beginnerFriendlyS: 'Alta',
    beginnerFriendlyN: 'Média',
    h2Faq: 'Perguntas Frequentes (FAQ)',
    faq1Q: 'O CSSBuy Spreadsheet é oficial?',
    faq1A: 'Não. Este é um recurso informativo independente. Não somos afiliados oficiais ao CSSBuy e não representamos a empresa. Nosso objetivo é fornecer guias e organização de informações para ajudar na pesquisa.',
    faq2Q: 'Como acesso o CSSBuy Spreadsheet?',
    faq2A: 'Você pode acessar o CSSBuy Spreadsheet através do nosso site principal. Navegue pelas categorias, explore os produtos e siga os links para mais informações.',
    faq3Q: 'O spreadsheet garante a qualidade dos produtos?',
    faq3A: 'Não. O spreadsheet organiza informações, mas não garante qualidade, autenticidade ou disponibilidade. Sempre verifique fotos de QC, preços e informações de envio antes de comprar.',
    faq4Q: 'Quais categorias estão disponíveis?',
    faq4A: 'As categorias incluem tênis, moletom, camisetas, jaquetas, calças, bolsas, acessórios, perfumes, cintos, headwear, sets, underwear, jersey e outros produtos.',
    faq5Q: 'É seguro usar o CSSBuy?',
    faq5A: 'O CSSBuy é uma plataforma conhecida, mas como qualquer serviço online, exige cuidado. Verifique URLs, proteja sua conta, confirme preços e utilize fotos de QC para verificar produtos.',
    ctaMain: 'Visitar Site Principal',
    ctaSpreadsheet: 'Explorar CSSBuy Spreadsheet',
    ctaSafety: 'Ler Guia de Segurança',
    tipLabel: 'Dica CSSBuy Spreadsheet',
    tipText: 'Use o spreadsheet para comparar vários produtos antes de decidir. Cruze informações de fotos de QC, custos de shipping e dados do vendedor para a melhor experiência.',
    bottomCtaText: 'Explore o CSSBuy Spreadsheet no site principal e encontre os produtos que você procura.',
    sidebarCtaText: 'Acesse o spreadsheet completo no site principal.',
    sidebarCategories: 'Categorias',
    toc: 'Conteúdo',
    tocWhat: 'O que é?',
    tocHow: 'Como Usar',
    tocCategories: 'Categorias',
    tocQc: 'QC e Fotos',
    tocShipping: 'Shipping Cost',
    tocSafety: 'Segurança',
    tocTable: 'Comparação',
    tocFaq: 'FAQ',
  },
  notFound: {
    message: 'Página não encontrada. Volte para a página inicial e explore o CSSBuy Spreadsheet.',
  },
};